<template>
  <div>
    <b-navbar-nav>
      <b-nav-item-dropdown
        class="dropdown-notification dropdown-no-scroll mr-25"
        menu-class="dropdown-menu-media"
        right
        no-caret
      >
        <template #button-content>
          <div class="bg-circle">
            <img
              class="responsive-icon"
              size="21"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1jYWxjdWxhdG9yIj48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMjAiIHg9IjQiIHk9IjIiIHJ4PSIyIi8+PGxpbmUgeDE9IjgiIHgyPSIxNiIgeTE9IjYiIHkyPSI2Ii8+PGxpbmUgeDE9IjE2IiB4Mj0iMTYiIHkxPSIxNCIgeTI9IjE4Ii8+PHBhdGggZD0iTTE2IDEwaC4wMSIvPjxwYXRoIGQ9Ik0xMiAxMGguMDEiLz48cGF0aCBkPSJNOCAxMGguMDEiLz48cGF0aCBkPSJNMTIgMTRoLjAxIi8+PHBhdGggZD0iTTggMTRoLjAxIi8+PHBhdGggZD0iTTEyIDE4aC4wMSIvPjxwYXRoIGQ9Ik04IDE4aC4wMSIvPjwvc3ZnPg=="
              @click="handleButtonClick"
            >
          </div>
        </template>
        <!-- Header -->
        <div class="my-container">
          <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex justify-content-center">
              <h4 class="calculator-title mb-0">
                Rate Calculator
              </h4>
            </div>
          </li>
          <li>
            <!-- Origin City -->
            <b-col cols="6">
              <b-form-group
                label=" Origin City"
                label-for="h-originCity"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-originCity"
                  vid="h-c-originCity"
                  rules="required"
                >
                  <v-select
                    v-model="origin_city_id"
                    :options="cityOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select City"
                    autocomplete="nope"
                    @change="getCalculateDeliveryCharge"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </li>
          <li>
            <b-col cols="6">
              <!-- Destination City -->
              <b-form-group
                label="Destination City"
                label-for="city"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-city"
                  vid="h-c-city"
                  rules="required"
                >
                  <v-select
                    v-model="form.destination_city_id"
                    :options="cityOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select City"
                    autocomplete="nope"
                    @change="getCalculateDeliveryCharge"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </li>
          <li>
            <b-col cols="6">

              <!-- Weight -->
              <b-form-group
                label="Weight"
                label-for="weight"
              >
                <ValidationProvider
                  #default="{ errors }"
                  name="h-c-weight"
                  vid="h-c-weight"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="weight"
                      v-model="form.weight"
                      type="number"
                      placeholder="1"
                      autocomplete="off"
                      step="0.01"
                      @change="getCalculateDeliveryCharge"
                    />
                    <b-input-group-append is-text>
                      <b>Kg</b>
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </b-form-group>
            </b-col>
          </li>
          <li>
            <b-col cols="6">
              <!-- Delivery charge -->
              <b-form-group
                label="Delivery Charge"
                label-for="delivery_charge"
              >
                <strong><input
                  id="delivery_charge"
                  v-model="delivery_charge"
                  type="text"
                  class="form-control"
                  disabled
                  autocomplete="off"
                ></strong>
              </b-form-group>
            </b-col>
          </li>
        </div>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BNavItemDropdown, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BNavbarNav,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
// eslint-disable-next-line import/extensions
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const ResourceRepository = RepositoryFactory.get('resource')
const CalculatorRepository = RepositoryFactory.get('calculator')
const MerchantRepository = RepositoryFactory.get('merchant')
export default {
  components: {
    BNavItemDropdown,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BFormInput,
    vSelect,
    BNavbarNav,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      originCities: [],
      destinationCities: [],
      cityOptions: [],
      origin_city_id: '',
      destination_city_id: '',
      form: {},
      weight: '',
      merchant_id: 0,
      delivery_charge: '',
    }
  },
  methods: {
    async handleButtonClick() {
      await this.getCityList()
      await this.getMerchantBusinessSettingsDetails()
    },
    async getCityList() {
      try {
        this.cityOptions = localStorage.getItem('city_list') ? JSON.parse(localStorage.getItem('city_list')) : (await ResourceRepository.getCityListDropdownList()).data.data
        if (!localStorage.getItem('city_list')) localStorage.setItem('city_list', JSON.stringify(this.cityOptions))
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getMerchantBusinessSettingsDetails() {
      try {
        const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await MerchantRepository.getMerchantBusinessSettingsDetails()).data.data
        if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
        this.merchant_id = data.merchant_id
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getCalculateDeliveryCharge() {
      try {
        this.loading = true
        const payload = {
          origin_city_id: this.origin_city_id,
          destination_city_id: this.form.destination_city_id,
          weight: this.form.weight,
          merchant_id: this.merchant_id,
        }
        const { data } = await CalculatorRepository.getCalculateDeliveryCharge(payload)
        this.delivery_charge = data['delivery charge']
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style>
.my-container {
  margin: 20px;
  padding: 10px;
}
.responsive-icon {
    width: 22px;
    height: 22px;
    color: white;
}
.bg-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: var(--primary);
  cursor: pointer;
  overflow: hidden; /* Ensure no extra content displays */
  margin: 0; /* Ensure no margin is causing issues */
  padding: 0; /* Ensure no padding is causing issues */
  position: relative; /* For positioning if needed */
}

.responsive-icon {
  display: block; /* Change to block to remove any inline space */
  width: 21px;
  height: 21px;
  color: white; /* Icon color */
  margin: 0; /* Remove any default margin */
  padding: 0; /* Remove any default padding */
  position: relative; /* Ensures the icon is positioned correctly */
  top: 0; /* Reset any vertical position */
}
@media (max-width: 768px) {
  .responsive-icon {
    width: 12px;
    height: 12px;
  }
}
</style>
